import React from 'react'
import style from './style.css'

export default (props) => (
    <div className={style.boxField} style={props.style || {}}>
        <label>
            <input
                className={`${style.text} ${(props.transparent) ? style.transparent : ''} ${props.className || ''}`}
                type='password'
                defaultValue={props.defaultValue}
                value={props.value}
                placeholder={props.placeholder || ' '}
                onChange={props.handleChange || null}
                name={props.name || ''}
                disabled={props.disabled}

                />

            {props.label && (
                <span className={style.placeholderFloat}>
                    <span className={style.placeholderFloatText}>{props.label}</span>
                    <hr className={style.lineWhite} />
                </span>
            )}
        </label>
    </div>
)


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/Forms/password.js